import { useLocation } from 'react-router-dom';

export function useScreenId() {
  const { pathname } = useLocation();

  return pathname.split('/')[1];
}
